import { Trans } from '@lingui/react'

import { Flex } from '@twisto/components/atoms/flex'
import { FormattedCurrencyNumber } from '@twisto/components/atoms/format'
import { Typography } from '@twisto/components/atoms/typography'
import { styleUtils } from '@twisto/styles'

import * as styles from './installment-offer-schedule-table.styles'

type Props = {
  periodsCount: number
  amountPerPeriod: string
}
export const InstallmentsOfferScheduleTableHeader = ({
  periodsCount,
  amountPerPeriod,
}: Props) => (
  <>
    <Typography
      align="center"
      color="textSecondary"
      css={styleUtils.margin.bottom.xs}
      textTransform="uppercase"
      variant="b3"
    >
      <Trans id="flow.components.installmentOfferScheduleTable.subtitle" />
    </Typography>
    <Flex
      alignItems="center"
      css={styleUtils.margin.bottom.lg}
      justify="center"
    >
      <Typography fontWeight="heavy" variant="h2">
        {periodsCount}
      </Typography>
      {/* eslint-disable-next-line react/jsx-no-literals */}
      <div css={styles.multiplicator}>&times;</div>
      <Typography fontWeight="heavy" variant="h2">
        <FormattedCurrencyNumber value={amountPerPeriod} />
      </Typography>
    </Flex>
  </>
)
